import React, { useEffect } from "react";
import { useState } from 'react';
import requireAuth from "../context/requireAuth";
import axios from "../context/axiosConfig";

function NewProduct() {

    const now = new Date(Date.now()).toISOString().split('T')[0];
    
    const [formData, setFormData] = useState({
        name: '',
        dateCreated: now,
        fresh: 'Y',
        dry: 'Y',
        location: 'vault',
        quantity: '',
        remark:''
    });

    const org_id = localStorage.getItem("organization");
  
    function handleSubmit(event) {
      event.preventDefault();
      axios.post(`orgs/${org_id}/products/`, formData, { withCredentials: true })
        .then(response => {
          console.log(response.data);
          const productCreated = response.data.map(product => product.org_product_no);
          alert(`Product created with upid: ${productCreated.join(', ')}`);
            document.querySelector('form').reset();
        })
        .catch(error => {
          console.error(error);
        });
    }
    
  
    function handleChange(event) {
      const value = event.target.value;
      setFormData({ ...formData, [event.target.name]: value });
    }   

    return (
      <div className="bodyContent">
        <h1 className="title">New Product</h1>
        <div className="editFormDiv">
          <form className="editForm" onSubmit={handleSubmit}>
          {/* <label htmlFor="upid">UPID</label>
          <input type="number" name="upid" id="upid" min="1" max="10000000000" className="editInput" value={formData.upid} onChange={handleChange} />
          <br /> */}
          <label htmlFor="name">Name</label>
          <input type="text" name="name" id="variety" className="editInput editSelect newMaintenanceInput" value={formData.name} onChange={handleChange} />
          <br />
          <label htmlFor="dateCreated">Creation Date</label>
          <input type="date" name="dateCreated" id="dateCreated" className="editInput editSelect newMaintenanceInput" value={now} onChange={handleChange} />
          <br />
          <label htmlFor="quantity">Quantity in grams</label>
          <input type="text" name="quantity" id="quantity" className="editInput editSelect newMaintenanceInput" value={formData.quantity} onChange={handleChange} />
          <br />
          <label htmlFor="fresh">Fresh (Yes/No)</label>
          <select name="fresh" id="fresh" className="editInput editSelect newMaintenanceInput" value={formData.fresh} onChange={handleChange}>
            <option value="Y">Y</option>
            <option value="N">N</option>
          </select>
          <br />
          <label htmlFor="dry">Dry (Yes/No)</label>
          <select name="dry" id="dry" className="editInput editSelect newMaintenanceInput" value={formData.dry} onChange={handleChange}>
            <option value="Y">Y</option>
            <option value="N">N</option>
          </select>
          <br />
          <label htmlFor="location">Location</label>
          <select name="location" id="location" className="editInput editSelect newMaintenanceInput" value={formData.location} onChange={handleChange}>
            <option value="vault">Vault</option>
            <option value="drying">Drying</option>
          </select>
          <br />
          <label htmlFor="remark">Remarks</label>
          <textarea name="remark" id="remark" className="editInput editSelect newMaintenanceInput" value={formData.remark} onChange={handleChange} cols="30" rows="7"/>
          <br />
          <input type="submit" value="Create Product" className="maintenanceFormSubmit" />
          </form>
        </div>
        </div>
      );
    }

export default requireAuth(NewProduct);